import { useEffect, useRef, useCallback } from 'react';
import useVideoContext from '../hooks/useVideoContext';
import { MUTE_AUDIO, TURNOFF_VIDEO} from '../constants';
import useLocalAudioToggle  from '../hooks/useLocalAudioToggle';
import useLocalVideoToggle from '../hooks/useLocalVideoToggle';
import { Logger } from '../utils';

export default function DataTrack({ track }) {
    const { room} = useVideoContext();
    const lastClickTimeRef = useRef(0);
    const [isVideoEnabled, toggleVideo] = useLocalVideoToggle();
    const [isAudioEnabled, toggleAudio] = useLocalAudioToggle();   

    const toggleParticipantVideo = useCallback(() => {       
        if (Date.now() - lastClickTimeRef.current > 500) {          
            lastClickTimeRef.current = Date.now();
            toggleVideo();
        }
    }, [toggleVideo]);    

    useEffect(() => {
        const handleMessage = (message) => {
            const localParticipant = room && room.localParticipant && room.localParticipant.identity ? room.localParticipant.identity : null;
            const messageObj = JSON.parse(message);
            
            if (messageObj && localParticipant) {
                const { eventName, identity } = messageObj;
                if (identity && identity === localParticipant) {
                    switch (eventName) {
                        case MUTE_AUDIO:
                            Logger("UI.Twilio.DataTrack.Receive.MuteAudio", new Date(), messageObj);
                            if (isAudioEnabled) {
                                toggleAudio();
                                Logger("UI.Twilio.DataTrack.Receive.MuteAudio.Success", new Date(), messageObj);
                            }
                            break;
                        case TURNOFF_VIDEO:
                            Logger("UI.Twilio.DataTrack.Receive.TurnOffVideo", new Date(), messageObj);
                            if (isVideoEnabled) {
                                toggleParticipantVideo();
                                Logger("UI.Twilio.DataTrack.Receive.TurnOffVideo.Success", new Date(), messageObj);
                            }
                            break;                        
                        default:
                            return;
                    }
                }
            }
          
        };
        track.on('message', handleMessage);
        return () => {
            track.off('message', handleMessage);
        };
    }, [track, isVideoEnabled, isAudioEnabled]);

    return null; 
}
